var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    staticClass: "drawer-body",
    attrs: {
      "width": _vm.AddNewSemicRecipeDrawerOpened ? 1000 : 800,
      "title": _vm.openedMaterial && _vm.openedMaterial.model
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_vm.AddNewSemicRecipeDrawerOpened ? _c('AddNewSemiRecipeDrawer', {
    ref: "AddNewSemiRecipeDrawer",
    on: {
      "closeDrawer": _vm.closeAddRecipeDrawer
    }
  }) : _c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "info-data"
  }, [_c('div', {
    staticClass: "sec-title"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.openedMaterial && _vm.openedMaterial.model) + " - " + _vm._s(_vm.openedMaterial && _vm.openedMaterial.name) + " ")])]), _c('div', {
    staticClass: "sec-title"
  }, [_c('div', [_vm._v("母液项目")])]), _vm.semiProduceFactoryList.length > 0 ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.semiItemTableLoading,
      "columns": _vm.semiItemColumns,
      "data": _vm.semiProduceFactoryList,
      "border": "",
      "size": "small"
    }
  })], 1) : _c('Alert', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("暂无母液项目")]), _c('div', {
    staticClass: "sec-title recipeList"
  }, [_c('div', [_vm._v("配方列表")]), _c('Button', {
    staticStyle: {
      "margin-top": "12px",
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.createNewRecipe
    }
  }, [_vm._v("创建配方")])], 1), _vm.recipeSemisList.length <= 0 ? _c('Alert', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("暂无配方")]) : _vm._l(_vm.recipeSemisList, function (r) {
    return _c('RecipeCard', {
      key: r._id,
      attrs: {
        "recipe": r,
        "recipeType": _vm.recipeType,
        "active": r._id === _vm.selectedRecipe._id
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.recipedClicked(r);
        }
      }
    });
  })], 2), _c('div', {
    staticClass: "recipe-data"
  }, [_vm.selectedRecipe._id ? _c('div', [_c('div', {
    staticClass: "recipe-top"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', [_vm._v(" #" + _vm._s(_vm.selectedRecipe.hasOwnProperty("NoId") ? _vm.selectedRecipe.NoId : "?") + " - ")]), _vm.isEdit ? _c('div', {
    staticClass: "current-material-name"
  }, [_c('Input', {
    staticStyle: {
      "line-height": "42px",
      "margin-left": "15px"
    },
    model: {
      value: _vm.selectedRecipe.name,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "name", $$v);
      },
      expression: "selectedRecipe.name"
    }
  }), _c('Icon', {
    staticStyle: {
      "margin-left": "12px",
      "vertical-align": "bottom",
      "cursor": "pointer",
      "color": "#2db7f5"
    },
    attrs: {
      "type": "ios-checkmark",
      "size": "36"
    },
    on: {
      "click": function ($event) {
        return _vm.saveField(false);
      }
    }
  }), _c('Icon', {
    staticStyle: {
      "margin-left": "12px",
      "vertical-align": "bottom",
      "cursor": "pointer",
      "color": "#f50"
    },
    attrs: {
      "type": "ios-close",
      "size": "36"
    },
    on: {
      "click": function ($event) {
        _vm.isEdit = false;
      }
    }
  })], 1) : _c('div', {
    staticClass: "current-material-name"
  }, [_c('h1', [_vm._v(" " + _vm._s(_vm.selectedRecipe.name) + " ")]), _c('Icon', {
    staticStyle: {
      "margin-left": "12px",
      "vertical-align": "bottom",
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-create-outline",
      "size": "26"
    },
    on: {
      "click": function ($event) {
        return _vm.editRecipeName(true);
      }
    }
  })], 1)]), _vm.isEdit ? _c('div', [_c('span', [_vm._v("含固量（如果是50%则填写50）: ")]), _c('InputNumber', {
    model: {
      value: _vm.selectedRecipe.solidContent,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "solidContent", $$v);
      },
      expression: "selectedRecipe.solidContent"
    }
  }), _c('br'), _c('span', [_vm._v("A料滴加时间: ")]), _c('InputNumber', {
    model: {
      value: _vm.selectedRecipe.dijiaATime,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "dijiaATime", $$v);
      },
      expression: "selectedRecipe.dijiaATime"
    }
  }), _c('br'), _c('span', [_vm._v("B料滴加时间: ")]), _c('InputNumber', {
    model: {
      value: _vm.selectedRecipe.dijiaBTime,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "dijiaBTime", $$v);
      },
      expression: "selectedRecipe.dijiaBTime"
    }
  }), _c('br'), _c('span', [_vm._v("C料滴加时间: ")]), _c('InputNumber', {
    model: {
      value: _vm.selectedRecipe.dijiaCTime,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "dijiaCTime", $$v);
      },
      expression: "selectedRecipe.dijiaCTime"
    }
  }), _c('br'), _c('span', [_vm._v("保温时间: ")]), _c('InputNumber', {
    model: {
      value: _vm.selectedRecipe.baowenTime,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "baowenTime", $$v);
      },
      expression: "selectedRecipe.baowenTime"
    }
  }), _c('br'), _c('span', [_vm._v("中和时间: ")]), _c('InputNumber', {
    model: {
      value: _vm.selectedRecipe.zhongheTime,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRecipe, "zhongheTime", $$v);
      },
      expression: "selectedRecipe.zhongheTime"
    }
  }), _c('br')], 1) : _c('div', [_c('h3', [_vm._v("含固量: " + _vm._s(_vm.selectedRecipe.solidContent) + "%")]), _c('h4', [_vm._v("A料滴加时间: " + _vm._s(_vm.selectedRecipe.dijiaATime) + "秒")]), _c('h4', [_vm._v("B料滴加时间: " + _vm._s(_vm.selectedRecipe.dijiaBTime) + "秒")]), _c('h4', [_vm._v("C料滴加时间: " + _vm._s(_vm.selectedRecipe.dijiaCTime) + "秒")]), _c('h4', [_vm._v("保温时间: " + _vm._s(_vm.selectedRecipe.baowenTime) + "秒")]), _c('h4', [_vm._v("中和时间: " + _vm._s(_vm.selectedRecipe.zhongheTime) + "秒")])])]), _c('div', {
    staticClass: "copy"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": ""
    },
    on: {
      "click": _vm.copyRecipe
    }
  }, [_vm._v("复制配方")])], 1)]), _c('RecipeTable', {
    ref: "RecipeTable"
  }), _c('div', {
    staticClass: "set-recipe"
  }, [_c('div', [_vm._v("将配方#" + _vm._s(_vm.selectedRecipe.NoId) + "设为生产（成本核算）配方")]), _c('CheckboxGroup', {
    staticStyle: {
      "margin": "12px 0"
    },
    model: {
      value: _vm.selectFactoryData,
      callback: function ($$v) {
        _vm.selectFactoryData = $$v;
      },
      expression: "selectFactoryData"
    }
  }, _vm._l(_vm.semiProduceFactoryList, function (item) {
    return _c('Checkbox', {
      key: item._id,
      attrs: {
        "label": item._id
      }
    }, [_vm._v(_vm._s(item.factory.name) + " ")]);
  }), 1), _c('Button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary",
      "ghost": "",
      "long": "",
      "disabled": this.selectFactoryData.length === 0
    },
    on: {
      "click": _vm.setProductRecipe
    }
  }, [_vm._v("设为生产配方")])], 1)], 1) : _c('Alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("暂无配方")])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }